import React from 'react';
//import PropTypes from 'prop-types';
import target from 'assets/img/icons/target.svg';
import discount from 'assets/img/icons/discount.svg';
import networking from 'assets/img/icons/networking.svg';
import { Card, Col, Image, Row } from 'react-bootstrap';

const data = [
 {
  id: 0,
  title: 'Mejore sus habilidades en el sector',
  description:
   'Mejore sus habilidades sumergiéndose en un entorno de aprendizaje con instrucción profesional y acceso limitado a la vez.',
  icon: target
 },
 {
  id: 1,
  title: 'Obtenga ofertas y descuentos',
  description:
   '¡Aproveche los descuentos en propiedades y conviértase en dueño de su sueño! En el mercado inmobiliario, es común encontrar descuentos en propiedades.',
  icon: discount
 },
 {
  id: 2,
  title: 'Redes de asesores y cliente',
  description:
   'Las redes son una poderosa sinergia en el mundo de los negocios. Estas redes establecen conexiones significativas permitiendo una colaboración efectiva y beneficios mutuos.',
  icon: networking
 }
];

const ProjectFeatures = () => {
 return (
  <Card className="mb-3 bg-transparent border shadow-none d-none d-sm-block">
   <Card.Body>
    <Row className="gy-4 text-center text-md-start">
     {data.map(({ id, title, icon, description }) => (
      <Col md={4} key={id}>
       <Image src={icon} alt="" width={36} className="mb-3" />
       <h6 className="fs-0 text-primary">{title}</h6>
       <p className="fs--1 mb-0">{description}</p>
      </Col>
     ))}
    </Row>
   </Card.Body>
  </Card>
 );
};

/* ProjectFeatures.propTypes = {
 data: PropTypes.arrayOf(PropTypes.object)
}; */

export default ProjectFeatures;
